import { Injectable } from "@angular/core";
import { PromiseLookupService } from "../../impl/PromiseLookupService";
import { IFixingSourcePromiseLookupService } from "../IFixingSourcePromiseLookupService";
import * as CubiqTS from "shared/cubiq-model-multi-asset";
import { LoggerService } from "@bfx/logger";
const logger = LoggerService.for(__dirname);

export abstract class FixingSourcePromiseLookupService
  extends PromiseLookupService<string, CubiqTS.NdfSourceImpl>
  implements IFixingSourcePromiseLookupService
{
  constructor() {
    super();
  }

  abstract getFixingSource(id: string): Promise<CubiqTS.NdfSourceImpl>;
  abstract getFixingSourcesForPair(pair: string): Promise<Array<any>>;
  abstract getFixingSourceInPair(fixingSourceCd: string, pair: string): Promise<any>;
  abstract getAllAdaptedFixingSources(): Promise<Array<any>>;
}
